export const isTestMode = () => process.env.NODE_ENV === "test";
export const isProductionMode = () => process.env.NODE_ENV === "production";
export const isDevMode = () => !isTestMode() && !isProductionMode();
